import { Component, ViewChild, OnInit,HostBinding, HostListener, Renderer2 } from '@angular/core';
import {OverlayContainer} from '@angular/cdk/overlay';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { LanguageService, AppLanguage } from '../../services/language.service';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { Role } from 'src/app/model/role';

@Component({
  selector: 'app-mainlayout',
  templateUrl: './mainlayout.component.html',
  styleUrls: ['./mainlayout.component.scss'],
})
export class MainlayoutComponent implements OnInit {

  isSysAdmin : boolean = false;
  isCustomerCare: boolean = false;
  isCustomerService : boolean =false;
  isExpenseRoleVisible : boolean = false;
  isEmployeesVisible : boolean = false;
  isSysAdminOrFinance : boolean = false;
  isSuperAdmin : boolean = false;
  isAdmin : boolean = false;
  isHr : boolean = false;
  isPayments : boolean = false;

  loggedInUserId: string | null = null;
  loggedInUserName: string | null = null;

  constructor(private cookieService: CookieService, private router: Router,private apiService: ApiService,private renderer: Renderer2,
    private overlayContainer: OverlayContainer, private languageService: LanguageService){
    // Dark theme is the default; only an explicit 'light' choice switches to light.
    this.darkModeUI = localStorage.getItem('theme') !== 'light';
    this.renderPageBodyColor();
    this.applyThemeToOverlayContainers();
  }

  
  ngOnInit(): void {
   // this.isSysAdmin = sessionStorage.getItem("issysadmin") === "true";
    this.checkLoginType();
  }
  @ViewChild('sidenav') sidenav: MatSidenav;
  isExpanded = true;
  public darkModeUI = false;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  emprole:String;
  checkLoginType() {
    const loggedInUser = window.localStorage.getItem('loggedInUser');
    this.loggedInUserId = loggedInUser;
    // this.apiService.getEmployeeDetailsById(loggedInUser).subscribe((data) => {
    //   this.emprole=data.employeeRole;
    // });
    this.apiService.getEmplyeeDetailsById(loggedInUser).subscribe((data : any) => {
      
       this.loggedInUserName = data.employeeName || null;

       let roles = data.roles.map((role : Role)=>role.roleName);
       if(roles.includes("sysadmin")){
        this.isSysAdmin = true;     
       }
        if(roles.includes("superadmin")){
        this.isSuperAdmin = true;     
       } 

         if(roles.includes("admin")){
        this.isAdmin = true;     
       } 
       if(roles.includes("hr")){
        this.isHr = true;
       }
       if(roles.includes("customercare") ){
        this.isCustomerCare = true; 
       }
        if(roles.includes("customerservice")){
         this.isCustomerService = true;
       }

        if(roles.includes("sysadmin") || roles.includes("finance") || (data.employeeDepartment =='collector' && (roles.includes("admin") || roles.includes("superadmin")))){
          this.isEmployeesVisible = true;
        }

        if(roles.includes("requester") || roles.includes("auditor") || roles.includes("approver")){
          this.isExpenseRoleVisible = true;
       }


          if(roles.includes("sysadmin") || roles.includes("finance")){
          this.isSysAdminOrFinance = true;
        }

       if(roles.includes("payments")){
          this.isPayments = true;
       }

       

       
    });
  }
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }
  logout(){
    this.cookieService.delete('LOGIN_TOKEN');
    this.router.navigate(['login']);
  }
  setLang(lang: string) {
    const value = lang === 'so' ? 'so' : 'en';
    this.languageService.setLanguage(value as AppLanguage);
  }
  @HostBinding('class')
  public get themeMode() {
    return this.darkModeUI ? 'dark-theme' : 'light-theme';
  }

  /**
   * Listen for changes of the toggle state in child component "header"
   * Change the value of darkModeUI accordingly
   * Call page body background color rendering
   * @param $event The boolean emitted by the child component
   */
  public getDarkThemeOn($event) {
    this.darkModeUI = $event;
    localStorage.setItem('theme', this.darkModeUI ? 'dark' : 'light');
    this.renderPageBodyColor();
    this.applyThemeToOverlayContainers();
  }

  /**
   * Change the page body background color to match the content background
   * The name of the class is a reference to a CSS class in the styles.scss file
   * For example, 'dark' activates the 'body.dark' CSS class
   * Current theme classes must be explicitly removed before assigning another one
   * @private
   */
  private renderPageBodyColor() {
    this.renderer.removeClass(document.body, 'dark');
    this.renderer.removeClass(document.body, 'light');
    this.renderer.addClass(document.body, this.darkModeUI ? 'dark' : 'light');
  }

  /**
   * Propagate dynamic theme change to overly containers (dialogs eg)
   * The name of the class is a reference to a CSS class in the styles.scss file
   * For example, 'dark' activates the 'body.dark' CSS class
   * Current theme classes must be explicitly removed before assigning another one
   * @private
   */
  private applyThemeToOverlayContainers() {
    const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
    const classesToRemove = Array.from(overlayContainerClasses).filter(item => item.includes('-theme'));
    overlayContainerClasses.remove(...classesToRemove);
    this.overlayContainer.getContainerElement().classList.add(this.darkModeUI ? 'dark-theme' : 'light-theme');
  }
}
